// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2XD6W","title":"styles_title__3SXvo","data":"styles_data__BtInW","item":"styles_item__2MqQF"};